"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconMessage = exports.IconMessageDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var icon_1 = require("./icon");
exports.IconMessageDefaultProps = {
  textColor: 'text',
  iconColor: 'textMid'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    font-family: ", ";\n    margin: ", ";\n    font-weight: 500;\n\n    ", ";\n\n    a {\n      color: ", ";\n      text-decoration: none;\n\n      &:hover {\n        color: ", ";\n      }\n    }\n  "], ["\n    ", ";\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    font-family: ", ";\n    margin: ", ";\n    font-weight: 500;\n\n    ", ";\n\n    a {\n      color: ", ";\n      text-decoration: none;\n\n      &:hover {\n        color: ", ";\n      }\n    }\n  "])), theme_1.theme.RESPONSIVE_FONT_SIZE('slight'), theme_1.theme.FONT('sans'), theme_1.theme.UNIT(6), function (_a) {
    var textColor = _a.textColor;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme_1.theme.COLOR(textColor));
  }, theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('dark')),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: ", ";\n  "], ["\n    margin: ", ";\n  "])), theme_1.theme.UNIT(10)),
  desktop: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: ", ";\n  "], ["\n    margin: ", ";\n  "])), theme_1.theme.UNIT(12))
});
var iconSizePatch = function (props) {
  return props.iconSize && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n"], ["\n  width: ", "px;\n  height: ", "px;\n"])), props.iconSize, props.iconSize);
};
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-right: ", ";\n\n    flex-shrink: 0;\n    width: ", ";\n    height: ", ";\n    ", ";\n  "], ["\n    margin-right: ", ";\n\n    flex-shrink: 0;\n    width: ", ";\n    height: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(5), theme_1.theme.UNIT(5), iconSizePatch),
  tablet: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n    ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(5), theme_1.theme.UNIT(5), iconSizePatch),
  desktop: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-right: ", ";\n    width: ", ";\n    height: ", ";\n    ", ";\n  "], ["\n    margin-right: ", ";\n    width: ", ";\n    height: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(6), theme_1.theme.UNIT(6), iconSizePatch),
  desktopLarge: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n    ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(7), theme_1.theme.UNIT(7), iconSizePatch)
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _color = _a._color;
    return (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      color: ", ";\n      flex-grow: 1;\n      \n      p {\n        margin-top: 0\n      }\n    "], ["\n      color: ", ";\n      flex-grow: 1;\n      \n      p {\n        margin-top: 0\n      }\n    "])), _color);
  }),
  tablet: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    flex-grow: 0;\n  "], ["\n    flex-grow: 0;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
var IconMessage = function (props) {
  var className = props.className,
    children = props.children,
    icon = props.icon,
    iconColor = props.iconColor,
    iconSize = props.iconSize,
    textColor = props.textColor;
  return React.createElement(My.Container, {
    textColor: textColor,
    className: className
  }, icon && React.createElement(My.Icon, {
    iconSize: iconSize,
    color: iconColor
  }, icon), React.createElement(My.Body, null, children));
};
exports.IconMessage = IconMessage;
exports.IconMessage.defaultProps = exports.IconMessageDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;